import { useRef, useEffect } from "react";

export function useDrag() {
  const ref = useRef(null);
  const isDown = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);
  const isDragging = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const handleMouseDown = (e) => {
      isDown.current = true;
      isDragging.current = false;
      startX.current = e.pageX - el.offsetLeft;
      scrollLeft.current = el.scrollLeft;
      el.classList.add("dragging");
    };

    const handleMouseLeave = () => {
      isDown.current = false;
      el.classList.remove("dragging");
    };

    const handleMouseUp = () => {
      isDown.current = false;
      el.classList.remove("dragging");
      setTimeout(() => (isDragging.current = false), 0);
    };

    const handleMouseMove = (e) => {
      if (!isDown.current) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      const walk = (x - startX.current) * 1;
      if (Math.abs(walk) > 5) isDragging.current = true;
      el.scrollLeft = scrollLeft.current - walk;
    };

    const handleClick = (e) => {
      if (isDragging.current) {
        e.stopPropagation();
        e.preventDefault();
      }
    };

    el.addEventListener("mousedown", handleMouseDown);
    el.addEventListener("mouseleave", handleMouseLeave);
    el.addEventListener("mouseup", handleMouseUp);
    el.addEventListener("mousemove", handleMouseMove);
    el.addEventListener("click", handleClick, true);

    // cleanup sempre que ref mudar
    return () => {
      el.removeEventListener("mousedown", handleMouseDown);
      el.removeEventListener("mouseleave", handleMouseLeave);
      el.removeEventListener("mouseup", handleMouseUp);
      el.removeEventListener("mousemove", handleMouseMove);
      el.removeEventListener("click", handleClick, true);
    };
  }, [ref.current]); // <- reexecuta quando o nó muda

  return ref;
}
